import RICUpdateFileType from "./RICUpdateFileType";
// import CryptoJS from "crypto-js";
import ESP32PartitionType from "./ESP32PartitionType";
import { unpack } from "./struct";

export default class PartitionTable {
    private _parsedOk: boolean = false;
    private MAGIC_BYTES = new Uint8Array([0xAA, 0x50])
    private _partitions = new Array<ESP32PartitionType>();

    public fromBinary(b: Uint8Array): ESP32PartitionType {
        const STRUCT_FORMAT = '<2sBBLL16sL'
        // eslint-disable-next-line
        const [_, type, subtype, offset, size, name, flags] = unpack(STRUCT_FORMAT, b);
        const part = new ESP32PartitionType(name as string, type as number, subtype as number, size as number, offset as number, flags as number);
        return part;
    }

    private toHex(b: Uint8Array): string {
        return b.reduce((s, v) => s + ('0' + v.toString(16)).slice(-2), '');
    }

    public getPartitionInfo(name: string): ESP32PartitionType | undefined {
        return this._partitions.find(p => p.name === name);
    }

    // Process the binary table
    public processTable(b: Uint8Array): boolean {

        // Iterate over binary in 32 byte chunks
        for (let i = 0; i < b.length; i += 32) {

            // Get 32 byte chunk
            const data = b.slice(i, i + 32);
            if (data.length !== 32) {
                throw new Error(`Partition length must be a multiple of 32 bytes. Got ${data.length} bytes.`);
            }

            // Check for md5 hash
            const md5Marker = new Uint8Array([0xeb, 0xeb, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff]);
            if (md5Marker.every((v, i) => v === data[i])) {
                continue;
            }

            // Check for end
            const endMarker = new Uint8Array(32).fill(0xff);
            if (endMarker.every((v, i) => v === data[i])) {
                return true;
            }

            // Add partition
            const newPartition = this.fromBinary(data);
            this._partitions.push(newPartition);

            // Debug
            console.log(`RICUpdater: processTable: ${this.toHex(data)} converted to ${newPartition.toStr()}`);
        }
        return false;
    }

    public process(partitionFileInfo: RICUpdateFileType) {

        // Debug
        console.log(`RICUpdater: process: ${partitionFileInfo.destname}`);

        // Check the length
        if (partitionFileInfo.binaryData.length < this.MAGIC_BYTES.length) {
            console.log(`RICUpdater: process: ${partitionFileInfo.destname} too short`);
            return;
        }

        // Check the magic bytes
        const magicBytes = partitionFileInfo.binaryData.slice(0, this.MAGIC_BYTES.length);
        if (!this.MAGIC_BYTES.every((v, i) => v === magicBytes[i])) {
            console.log(`RICUpdater: process: ${partitionFileInfo.destname} bad magic bytes`);
            return;
        }

        // Debug
        console.log(`RICUpdater: process: ${partitionFileInfo.destname} good magic bytes`);

        // Process the table
        this._parsedOk = this.processTable(partitionFileInfo.binaryData);
    }

    public get parsedOk(): boolean {
        return this._parsedOk;
    }
}
